module.exports = __webpack_public_path__ + "static/media/nakazaniq.cb944701.pdf";